import JsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MADRID_CENTER_NAME, VALENCIA_CENTER_NAME, ANDALUCIA_CENTER_NAME, CANARIAS_CENTER_NAME } from '../data/CertificateReportsDataApiConstants.js';

//Imágenes a utilizar para formar el pdf
import logoM from '../img/logo_madrid.png';
import logoC from '../img/logo_canarias.png';
import logoV from '../img/logo_valencia.png';
import logoA from '../img/logo_andalucia.jpg';
import firmaM from '../img/firma_madrid.png';
import firmaC from '../img/firma_canarias.png';
import firmaV from '../img/firma_valencia.png';
import firmaAndalucia from '../img/firma_andalucia.png';
import selloM from '../img/sello_madrid.png';
import selloV from '../img/sello_valencia.png';
import selloA from '../img/sello_andalucia.png';

//Valores RGPD
import { textPdfV, textPdfM, textPdfC, textPdfA } from '../data/textConstants.js';

function filterCentersByFaculty(faculty, reportData){
    return [...reportData.map((item) => {
        if(item.doc_identi === faculty){
            return {
                label: item.desc_centro + ' (' + item.desc_poblacion + ')',
                value: item.desc_centro
            }
        };
    })
    .filter((item) => item)
    .filter((item, index, self) =>
        index === self.findIndex((t) => (
            t.value === item.value
        )
    ))];
}

//Función para cargar imágenes en el pdf de manera asíncrona
const loadImages = (sources) => {
    const loadImage = (src) => new Promise((resolve, reject) => {
        if (!src) {
            resolve(null);
        } else {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`Error al cargar la imagen: ${src}`));
            img.src = src;
        }
    });
    return Promise.all(sources.map(src => loadImage(src)));
};




async function generatePDF(filters, facultyName, filteredRows) {
    const fecha = new Date();
    const opciones = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const fechaFormateada = fecha.toLocaleDateString('es-ES', opciones);

    const doc = new JsPDF();

    //Variables auxiliares que nos ayudan a cambiar el valor de cada imagen dependiendo de cada tipo de pdf
    var stampHeightAux = 25;
    var textProfesorY = 0;
    var tableY = 0;
    var textTable = '';
    var textFooter = '';
    var logoHeight = 0;
    var textPdf = '';

    //Según el centro carga unas imágenes u otras
    let sources = {
        img: filters.centro.includes(VALENCIA_CENTER_NAME) ? logoV : (filters.centro.includes(MADRID_CENTER_NAME) ? logoM : (filters.centro.includes(ANDALUCIA_CENTER_NAME) ? logoA : logoC)),
        imgStamp: filters.centro.includes(VALENCIA_CENTER_NAME) ? selloV : (filters.centro.includes(MADRID_CENTER_NAME) ? selloM : (filters.centro.includes(ANDALUCIA_CENTER_NAME) ? selloA : selloM)),
        imgSignature: filters.centro.includes(VALENCIA_CENTER_NAME) ? firmaV : (filters.centro.includes(MADRID_CENTER_NAME) ? firmaM : (filters.centro.includes(ANDALUCIA_CENTER_NAME) ? firmaAndalucia : firmaC)),
    };

    //Uso de la función para cargar las imágenes de manera asíncrona
    const [img, imgStamp, imgSignature] = await loadImages(Object.values(sources));

    //Aqui modificaremos los valores de cada imagen para poder adaptarlas al pdf como queramos
    if(filters.centro.includes("La Orotava") || filters.centro.includes(CANARIAS_CENTER_NAME)){
        textProfesorY = 100; //Coordenada Y del nombre del profesor
        tableY = 115; //Coordenada Y de la tabla
        textTable = 'Canarias';
        textFooter = 'Universidad Europea de Canarias | Inocencio García Feo, 1 38300 La Orotava TENERIFE';
        logoHeight = 30; //Tamaño del logo
        textPdf = textPdfC; //Texto que utilizamos almacenado en una constante en el archivo data/textConstants.js

    } else if(filters.centro.includes(VALENCIA_CENTER_NAME)){
        stampHeightAux = 15;
        textProfesorY = 100;
        tableY = 115;
        textTable = 'Valencia';
        textFooter = 'Universidad Europea de Valencia | Paseo de la Alameda, 7 46010 Valencia VALENCIA';
        logoHeight = 30;
        textPdf = textPdfV;

    } else if(filters.centro.includes(ANDALUCIA_CENTER_NAME)){
        stampHeightAux = 25;
        textProfesorY = 110;
        tableY = 125;
        textTable = 'Málaga';
        textFooter = 'Universidad Europea de Andalucía | Calle Eolo nº 10 - 29010 Málaga';
        logoHeight = 30;
        textPdf = textPdfA;

    } else {
        stampHeightAux = 20;
        textProfesorY = 100;
        tableY = 115;
        textTable = 'Villaviciosa de Odón';
        textFooter = 'Universidad Europea de Madrid | Tajo, s/n. Urbanización El Bosque 28670 Villaviciosa de Odón MADRID';
        logoHeight = 30;
        textPdf = textPdfM;
    }

    //Valores de las imágenes para mantener su proporción original
    const imgWidth = img.width;
    const imgHeight = img.height;
    const headerHeight = logoHeight;
    const headerWidth = ((imgWidth * headerHeight) / imgHeight);

    const signatureHeight = 45;
    const signatureWidth = 170;

    //Primer texto del pdf
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.setLineHeightFactor(1.7);
    const pageWidth = doc.internal.pageSize.getWidth() - 20;
    const lines = doc.splitTextToSize(textPdf, pageWidth);

    doc.text(lines, 10, 50, { maxWidth: pageWidth, align: "justify" });

    //Encabezado
    //El metodo text y addImage tienen estos parametros
    //en común (valor, coordenada_X, coordenada_Y, Ancho, Alto)
    doc.addImage(img.src, 'PNG', 10, 10, headerWidth, headerHeight);

    //Nombre del profesor en el pdf
    doc.setFontSize(16);
    doc.setFont('helvetica', 'italic');
    doc.text(`${facultyName}`, 100, textProfesorY, null, null, 'center');

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text('con las siguientes puntuaciones:', 15, textProfesorY + 10);

    //Estilos de la tabla
    const headerStyles = {
        fillColor: [196, 48, 43],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 9,
        overflow: 'linebreak'
    };

    const bodyStyles = {
        fontSize: 9,
        minCellHeight: 13
    };

    const columnStyles = {
        halign: 'center'
    }

    const escalaStyles = {
        cellWidth: 33 ,
        halign: 'center'
    }

    const escalaLastTableStyles02 = {
        cellWidth: 35 ,
        halign: 'center'
    }

    const escalaLastTableStyles03 = {
        cellWidth: 20 ,
        halign: 'center'
    }

    //Definición de la tabla
    let tableRows = filteredRows.slice(0, filteredRows.length - 1);
    autoTable(doc, {
        margin: { bottom: 20 },
        startY: tableY,
        head: [['Curso académico', 'Asignatura', 'Satisfacción Global (Escala 1 a 5)', 'Nº\nRespuestas']],
        body: tableRows.map(
            item => [
                ((item.cur_academ) ? item.cur_academ : '') + '/' + (Number(item.cur_academ)+1),
                ((item.desc_asignatura) ? item.desc_asignatura.toUpperCase() : '') + ' (' + ((item.desc_titulacion) ? item.desc_titulacion.toUpperCase() : '' ) + ' - ' + ((item.cod_grupo_simple) ? item.cod_grupo_simple.toUpperCase() : '') + ')',
                Number(item.med_resp_prof).toFixed(2),
                ((item.num_resp_prof) ? item.num_resp_prof : '')
            ]
        ),
        headStyles: headerStyles,
        bodyStyles: bodyStyles,
        columnStyles: {
            0: columnStyles,
            2: escalaStyles,
            3: columnStyles
        },

        didParseCell: function (data) {
            if (data.section === 'head') {
            if (data.column.index === 0) data.cell.styles.cellWidth = 20;
            if (data.column.index === 1) data.cell.styles.cellWidth = 107.7;
            if (data.column.index === 2) data.cell.styles.cellWidth = 33;
            if (data.column.index === 3) data.cell.styles.cellWidth = 21;
            }
        },

        didDrawPage: function (data) {
            data.settings.margin.top = 35;
            data.settings.margin.bottom = 20;
        }
    });

    let tableFinalY = doc.lastAutoTable.finalY || 20;

    if((tableFinalY + 100) > doc.internal.pageSize.getHeight()){ //Comprobación para ver si la firma + sello + última fila cabe en la página
        doc.addPage();
        autoTable(doc, {
            startY: 40,
            head: [['Curso académico', 'Asignatura', 'Satisfacción Global (Escala 1 a 5)', 'Nº Respuestas']],
            body: filteredRows.slice(filteredRows.length - 1).map(
                item => [
                    ((item.cur_academ) ? item.cur_academ : '') + '/' + (Number(item.cur_academ)+1),
                    ((item.desc_asignatura) ? item.desc_asignatura.toUpperCase() : '') + ' (' + ((item.desc_titulacion) ? item.desc_titulacion.toUpperCase() : '' ) + ' - ' + ((item.cod_grupo_simple) ? item.cod_grupo_simple.toUpperCase() : '') + ')',
                    Number(item.med_resp_prof).toFixed(2),
                    ((item.num_resp_prof) ? item.num_resp_prof : '')
                ]
            ),
            headStyles: headerStyles,
            bodyStyles: bodyStyles,
            columnStyles: {
                0: columnStyles,
                2: escalaStyles,
                3: columnStyles
            },

            didParseCell: function (data) {
                if (data.section === 'head') {
                if (data.column.index === 0) data.cell.styles.cellWidth = 20;
                if (data.column.index === 1) data.cell.styles.cellWidth = 107.7;
                if (data.column.index === 2) data.cell.styles.cellWidth = 33;
                if (data.column.index === 3) data.cell.styles.cellWidth = 21;
                }
            },

            didDrawPage: function (data) {
                data.settings.margin.top = 40;
            }
        });
    }else{
        autoTable(doc, {
            startY: tableFinalY,
            body: [filteredRows[filteredRows.length - 1]].map(
                item => [
                    ((item.cur_academ) ? item.cur_academ : '') + '/' + (Number(item.cur_academ)+1),
                    ((item.desc_asignatura) ? item.desc_asignatura.toUpperCase() : '') + ' (' + ((item.desc_titulacion) ? item.desc_titulacion.toUpperCase() : '' ) + ' - ' + ((item.cod_grupo_simple) ? item.cod_grupo_simple.toUpperCase() : '') + ')',
                    Number(item.med_resp_prof).toFixed(2),
                    ((item.num_resp_prof) ? item.num_resp_prof : '')
                ]
            ),
            bodyStyles: bodyStyles,
            columnStyles: {
                0: columnStyles,
                2: escalaLastTableStyles02,
                3: escalaLastTableStyles03

            },
            didDrawPage: function (data) {
                data.settings.margin.top = 40;
            }
        });
    }

    //Detectar coordenadas donde acaba la tabla para añadir texto de manera dinámica
    tableFinalY = doc.lastAutoTable.finalY || 20;
    const marginBottom = 10;
    tableFinalY += marginBottom;

    let totalFinalY = tableFinalY;


    if(totalFinalY > doc.internal.pageSize.getHeight()){
        doc.addPage();
        tableFinalY = 40;
    }

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    if(filters.centro.includes(ANDALUCIA_CENTER_NAME)) {
        doc.text(`Para que así conste, en ${textTable}, a ${fechaFormateada.split(",")[1].trim()}`, 15, tableFinalY);

    } else {
        doc.text(`Para que conste, en ${textTable} a ${fechaFormateada}`, 15, tableFinalY);
    }

    //Firma
    doc.addImage(imgSignature.src, 'PNG', 20, tableFinalY + 2, signatureWidth, signatureHeight);
    const pageCount = doc.internal.getNumberOfPages();

    //Bucle para iterar el footer según el número de páginas que se genere del pdf
    for (let i = 1; i <= pageCount; i++) {

        //Texto del footer
        doc.setFont('helvetica', 'italic');
        doc.setPage(i);
        doc.setFontSize(9);
        const x = 190;
        const y = doc.internal.pageSize.getHeight() - 8;
        const lineHeight = 0.1;

        //Línea del footer
        doc.setLineWidth(lineHeight);
        doc.line(2, y - 5, 200, y - 5);
        doc.text(`${textFooter}`, x, y, null, null, 'right');

        doc.setFillColor(196, 48, 43); // Color rojo
        // Dibuja el rectángulo con color de fondo
        const rectWidth = 10; // Ancho del rectángulo
        const rectHeight = 8; // Alto del rectángulo
        const rectX = pageWidth + 2; // 10 es el margen derecho
        const rectY = doc.internal.pageSize.getHeight() - rectHeight - 5.1; // 10 es el margen inferior
        doc.rect(rectX, rectY, rectWidth, rectHeight, 'F'); // 'F' significa relleno

        // Configura el color del texto para el número de página
        doc.setTextColor(255, 255, 255); // Color blanco
        doc.setFontSize(8); // Establece el tamaño de la fuente para el número de página
        // Añade el número de página centrado en el rectángulo
        const pageNumX = rectX + rectWidth / 2;
        const pageNumY = rectY + rectHeight / 2 + 2.5; // Ajusta según la altura de la fuente
        doc.text(String(i), pageNumX, pageNumY, { align: 'center' });


        //Condicional para cargar el sello si no es de canarias o si no es la ultima pagina
        if ((!filters.centro.includes("La Orotava") && !filters.centro.includes(CANARIAS_CENTER_NAME)) && i !== pageCount) {
            const stampHeight = 15;
            const stampWidth = 30;
            doc.setFont('helvetica', 'italic');
            doc.setPage(i);
            doc.setFontSize(9);
            doc.setTextColor(0, 0, 0);
            doc.addImage(imgStamp.src, 'PNG', 3,  doc.internal.pageSize.getHeight() - 18, stampWidth, stampHeight);
        }

        //Añadir el sello si es la ultima pagina debajo de la firma
        if (i === pageCount) {
            doc.setFont('helvetica', 'italic');
            doc.setPage(i);
            doc.setFontSize(9);
            doc.setTextColor(0, 0, 0);
            const stampHeight = stampHeightAux;
            const stampWidth = 40;
            if (!filters.centro.includes("La Orotava") && !filters.centro.includes(CANARIAS_CENTER_NAME)) {
                doc.addImage(imgStamp.src, 'PNG', 20,  tableFinalY + signatureHeight , stampWidth , stampHeight );
            }
        }

        if (i !== 1) {
            doc.setFont('helvetica', 'italic');
            doc.setPage(i);
            doc.setFontSize(9);
            doc.setTextColor(0, 0, 0);
            doc.addImage(img.src, 'PNG', 10, 10, 65, 15)
        }
    }

    doc.save(`Certificado ${facultyName}.pdf`);
}

async function generateXSL(filteredRows, facultyName) {
    var dataTableRows = [];
    filteredRows.forEach(element => {
        dataTableRows.push({
            "Curso académico": element.cur_academ + "/" + (Number(element.cur_academ) + 1),
            "Asignatura": element.desc_asignatura.toUpperCase() + " (" + element.desc_titulacion.toUpperCase() + " - " + element.cod_grupo_simple + ")",
            "Satisfacción Global (Escala 1 a 5)": Number(element.med_resp_prof).toFixed(2),
            "Nº Respuestas": element.num_resp_prof
        })
    });
    console.log(dataTableRows);
    const worksheet = XLSX.utils.json_to_sheet(dataTableRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Reporte');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(data, facultyName + '.xlsx');
};

export { filterCentersByFaculty, generatePDF, generateXSL }